module.exports = __webpack_public_path__ + "img/9387954.jpg";